// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q81j","placeholdersHeader":"styles_placeholdersHeader__3iush","editorStyle":"styles_editorStyle__25yK5","placeholdersBox":"styles_placeholdersBox__3WQgQ"};